export { Assignation, isAssignationActive, getActiveAssignations } from "@daytrip/legacy-models";
